import { render, staticRenderFns } from "./VMassEdit.vue?vue&type=template&id=a60196de&"
import script from "./VMassEdit.vue?vue&type=script&lang=js&"
export * from "./VMassEdit.vue?vue&type=script&lang=js&"
import style0 from "./VMassEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports